(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  const details = document.getElementById('collection-description');

  details.addEventListener("click", function (e) {
    if(this.classList.contains("active")) {
      this.classList.remove("active");
    } else {
      this.classList.add("active");
    }
  });

  } catch(e) { console.error(e); }
})();
})();
